import * as React from "react";
import { PageType, ChildProps } from "../main/main";
import Question from "../question/question";
import { surveyQuestionsData } from "./survey-data";

import styles from "./survey.module.scss";

import { ReactComponent as ArrowRight } from "../../style/assets/arrow-right.svg";

export type SurveyData = {
    gender: string;
    ageRange: string;
    location: string;
    frequentActivity: string;
};

const Survey = (props: ChildProps & { quiz: string }) => {
    const { setFooter, setPage } = props;

    const initialAnswers: SurveyData = {
        gender: "",
        ageRange: "",
        location: "",
        frequentActivity: "",
    };
    const [answers, setAnswers] = React.useState(initialAnswers);
    const [buttonText, setButtonText] = React.useState("Start quiz");

    React.useEffect(() => {
        setFooter({
            Button: (
                <button
                    className={"quiz_button"}
                    onClick={() => {
                        sessionStorage.setItem("surveyData", JSON.stringify(answers));
                        setPage(PageType.question);
                    }}
                >
                    {buttonText}
                    <ArrowRight className={"arrow"} title="Start quiz" />
                </button>
            ),
        });
    }, [setFooter, setPage, buttonText, answers]);

    React.useEffect(() => {
        if (Object.values(answers).some(a => a !== "")) {
            setButtonText("Submit and start quiz");
        }
    }, [answers]);

    const setAnswer = (answer: any) => {
        setAnswers({ ...answers, ...answer });
    };

    const title =
        props.quiz === "GB"
            ? "Test your general boating safety knowledge"
            : props.quiz === "PWC"
            ? "Test your personal watercraft safety knowledge"
            : "";

    return (
        <div>
            <div className={styles.title}>{title}</div>
            {surveyQuestionsData.map(x => {
                return (
                    <Question
                        key={x.id}
                        question={x}
                        setAnswer={setAnswer}
                        selectedAnswer={answers[x.id as keyof SurveyData]}
                    />
                );
            })}
        </div>
    );
};

export default Survey;
